var app = angular.module('app', []);

app.controller('AppController', ['$scope', '$window', '$http', '$templateCache', 'globals', '$document', function($scope, $window, $http, $templateCache, globals, $document) {

    $scope.globals = globals;

}]);

app.factory('globals', [function() {

    var globals = {
        maxBedragPerLening : 75000,
        maxBedragTotaal : 150000,
        minBedragPerLening: 5000,
        checkAge : function (value){

                $date = value;

                if ($date === '' || $date == '0000-00-00')
                    isValid = false;

                var today = new Date();
                var birthDate = new Date($date);
                var age = today.getFullYear() - birthDate.getFullYear();
                var m = today.getMonth() - birthDate.getMonth();
                if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                    age--;
                }
                if(age < 21){
                    isValid = false;
                }else if(age > 67)
                {
                    isValid = false;
                }
                else{
                    isValid = true;
                }

               return isValid;
            },
    };

    return globals;

}]);

app.directive('ieSelectFix', ['$document',
        function($document) {

            return {
                restrict: 'A',
                require: 'ngModel',
                link: function(scope, element, attributes, ngModelCtrl) {
                    var isIE = $document[0] && $document[0].attachEvent;
                    if (!isIE) return;

                    var control = element[0];
                    //to fix IE8 issue with parent and detail controller, we need to depend on the parent controller
                    scope.$watch(attributes.ieSelectFix, function() {
                        // setTimeout is needed starting from angular 1.3+
                        setTimeout(function() {
                            //this will add and remove the options to trigger the rendering in IE8
                            var option = document.createElement("option");
                            control.add(option,null);
                            control.remove(control.options.length-1);
                        }, 0);
                    });
                }
            };
        }
    ]
);

function getBankImages(type){

    if(type == 'mobile'){
        $images = {
            'defam' : '/img/banken-mobiel/defam.jpg',
            'defam premium' : '/img/banken-mobiel/defam-premium.jpg',
            'Defam premium' : '/img/banken-mobiel/defam-premium.jpg',
            'ABN Amro' : '/img/banken-mobiel/abn-amro.jpg',
            'Santander' : '/img/banken-mobiel/santander.jpg',
            'MoneYou' : '/img/banken-mobiel/moneyou.gif',
            'SNS Bank' : '/img/banken-mobiel/snsbank.png',
            'Rabobank' : '/img/banken-mobiel/rabobank.jpg',
            'ING' : '/img/banken-mobiel/ing.jpg',
            'interbank' : '/uploads/images/banken/interbank2.png',
            'nn' : '/img/banken-mobiel/nationale-nederlanden.jpg',
            'Nationale Nederlanden' : '/img/banken-mobiel/nationale-nederlanden.jpg',
            'Sygma' : '/img/banken-mobiel/qander.jpg',
            'Qander' : '/img/banken-mobiel/qander.jpg',
            'Directa' : '/img/banken-mobiel/directa.jpg',
            'Findio' : '/img/banken-mobiel/findio.png',
            'Freo' : '/img/banken-mobiel/freo.jpg',
            'BNP' : '/uploads/images/banken/bnp.jpg'
        };
    }
    else{
        $images = {
            'defam': '/uploads/images/banken/defam_2.png',
            'defam premium': '/uploads/images/banken/defampremium.jpg',
            'Defam premium': '/uploads/images/banken/defampremium.jpg',
            'ABN Amro': '/uploads/images/banken/abnamro.jpg',
            'Santander': '/uploads/images/banken/santander.gif',
            'MoneYou': '/uploads/images/banken/moneyou.gif',
            'SNS Bank': '/uploads/images/banken/snsbank.png',
            'Rabobank': '/uploads/images/banken/rabobank.jpg',
            'ING': '/uploads/images/banken/ing.jpg',
            'interbank': '/uploads/images/banken/interbank2.png',
            'nn': '/uploads/images/banken/nationalenederlanden.jpg',
            'Nationale Nederlanden': '/uploads/images/banken/nationalenederlanden.jpg',
            'Sygma': '/uploads/images/banken/qander.jpg',
            'Qander': '/uploads/images/banken/qander.jpg',
            'Directa': '/uploads/images/banken/directa.jpg',
            'Findio': '/uploads/images/banken/findio.png',
            'Freo': '/uploads/images/banken/freo.jpg',
            'BNP' : '/uploads/images/banken/bnp.jpg'
        };
    } 
     

    return $images;
}